// extracted by css-extract-rspack-plugin
export default {"danger":"MilestoneDescription-module__danger__re_tqa6","subtle":"MilestoneDescription-module__subtle__p2CBryn"};